var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmallRate4(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 15c0 8.284-6.716 15-15 15-8.284 0-15-6.716-15-15C0 6.716 6.716 0 15 0c8.284 0 15 6.716 15 15z",
    fill: "#10B981"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.448 11.508c0 1.294-.735 2.344-1.64 2.344-.907 0-1.642-1.05-1.642-2.344 0-1.295.735-2.344 1.641-2.344s1.64 1.05 1.64 2.344zM20.885 11.508c0 1.294-.734 2.344-1.64 2.344-.907 0-1.641-1.05-1.641-2.344 0-1.295.735-2.344 1.64-2.344.907 0 1.641 1.05 1.641 2.344z",
    fill: "#111827"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 20c1.207 0 2.509-.434 4.38-1.502a1.25 1.25 0 111.24 2.171c-2.017 1.151-3.771 1.83-5.62 1.831-1.848 0-3.603-.677-5.62-1.832a1.25 1.25 0 111.24-2.17C12.493 19.568 13.793 20 15 20z",
    fill: "#111827"
  })));
}
export default SvgSmallRate4;